module.exports = __webpack_public_path__ + "static/media/load_white.e8656b5d.svg";